import { createContext, useContext } from "react";
import { noop } from "@common/helpers/function";
import { FinancialDocumentDetailsView } from "./usePathBasedFinancialDocumentDetailsView";

interface FinancialDocumentDetailsContext {
    currentView: FinancialDocumentDetailsView;
    changeView(view: FinancialDocumentDetailsView): void;
    isMaximized: boolean;
    toggleMaximized(): void;
    shouldShowNavigation: boolean;
    canGoToPrevious: boolean;
    canGoToNext: boolean;
    goToPrevious(): void;
    goToNext(): void;
}

export const financialDocumentDetailsContext =
    createContext<FinancialDocumentDetailsContext>({
        currentView: FinancialDocumentDetailsView.DEFAULT,
        changeView: noop,
        isMaximized: false,
        toggleMaximized: noop,
        shouldShowNavigation: false,
        canGoToPrevious: false,
        canGoToNext: false,
        goToPrevious: noop,
        goToNext: noop,
    });

export function useFinancialDocumentDetailsContext() {
    const ctx = useContext(financialDocumentDetailsContext);

    if (!ctx) {
        throw new Error(
            "useFinancialDocumentDetailsContext must be used within a FinancialDocumentDetailsProvider",
        );
    }

    return ctx;
}
